
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-accolade-logo{
  display:flex;
  align-items:flex-start;
  gap:1rem;
  max-width:350px;
  padding:4px;
  position:relative;
  flex-direction:column;
}

  @media (min-width: 1024px){.se-accolade-logo{
    align-items:center;
    flex-direction:row
}
  }

  .se-accolade-logo .logo{
    display:flex;
    align-items:center;
    justify-content:center;
    height:150px;
    width:150px;
    aspect-ratio:1 / 1;
    border:1px solid var(--brand-neutral-gray-800);
  }

  .se-accolade-logo .logo img{
      width:100%;
      aspect-ratio:1;
      object-fit:contain;
    }

  .se-accolade-logo [cloned-slot-name='logo']{
    height:100%;
    width:100%;
  }

  .se-accolade-logo se-link outline-icon{
      display:inline-flex;
      transition-duration:0.5s;
      vertical-align:middle;
    }

  .se-accolade-logo se-link .link{
      font-size:var(--fs-base);
      color:var(--brand-neutral-gray-800);
      text-decoration:none;
    }

  .se-accolade-logo se-link .link::after{
        content:'';
        position:absolute;
        inset:0px;
      }

  .se-accolade-logo se-link .link:hover{
        cursor:pointer;
      }

  .se-accolade-logo se-link .link:hover outline-icon{
          transform:translateX(50%);
        }
`;